import React from 'react';

import Spreader from '../Spreader';

import './styles.css';

function HeaderSlider() {
  return (
    <div className="HeaderSlider">
      <div className="HeaderSlider__vehicles"></div>
      <Spreader style={{ height: '100%' }}>
        <div className="HeaderSlider__promo-wrap">
          <div className="HeaderSlider__promo-text">5G</div>
          <div className="HeaderSlider__promo-shadow HeaderSlider__promo-shadow-1"></div>
          <div className="HeaderSlider__promo-shadow HeaderSlider__promo-shadow-2"></div>
          <div className="HeaderSlider__promo-shadow HeaderSlider__promo-shadow-3"></div>
        </div>
        <div className="HeaderSlider__title">Держи 5G</div>
      </Spreader>
    </div>
  );
}

export default HeaderSlider;
